import { apiClient } from "..";
import { ScanInfoRequest, ScanInfoResponse, ScanCountResponse, ScanInfoData, DrawPdfResponse, InvalidInvoiceResponse, ScanLogRequest, ScanLogResponse, ScanResetRequest, ScanResetResponse, InboundCancelRequest, InboundCancelResponse, ScanCancelLogResponse, ScanHawbInboundRequest, ScanInboundRequest } from "../types/scan";

export class ScanService {
  static async postInfo(payload: ScanInfoRequest): Promise<ScanInfoResponse> {
    return apiClient.post<ScanInfoResponse>("/scan/info", payload);
  }

  // v2 통합 입고: 조회·PDF출력·입고 저장을 단일 트랜잭션으로 처리
  static async scanInbound(payload: ScanInboundRequest): Promise<ScanInfoResponse> {
    return apiClient.post<ScanInfoResponse>("/v2/scan/inbound", payload);
  }

  static async count(): Promise<ScanCountResponse> {
    return apiClient.post<ScanCountResponse>("/scan/countV2");
  }

  static async drawPdf(data: ScanInfoData): Promise<DrawPdfResponse> {
    return apiClient.post<DrawPdfResponse>("/scan/draw/pdf", data);
  }

  static async postInvalidInvoice(data: ScanInfoData): Promise<InvalidInvoiceResponse> {
    return apiClient.post<InvalidInvoiceResponse>("/scan/invalid-invoice", data);
  }

  static async updateScanInfo(data: ScanInfoData): Promise<{ status: number; success: boolean; message: string }> {
    return apiClient.post("/scan/update/scanInfo", data);
  }

  static async getLog(payload: ScanLogRequest): Promise<ScanLogResponse> {
    return apiClient.post<ScanLogResponse>("/scan/log", payload);
  }

  static async reset(payload: ScanResetRequest): Promise<ScanResetResponse> {
    return apiClient.post<ScanResetResponse>("/scan/reset", payload);
  }

  static async cancelInbound(payload: InboundCancelRequest): Promise<InboundCancelResponse> {
    return apiClient.post<InboundCancelResponse>("/inbound/inscan/cancel", payload);
  }

  static async getCancelLog(payload: ScanLogRequest): Promise<ScanCancelLogResponse> {
    return apiClient.post<ScanCancelLogResponse>("/scan/cancelLog", payload);
  }

  static async scanInboundByHawb(payload: ScanHawbInboundRequest): Promise<ScanInfoResponse> {
    return apiClient.post<ScanInfoResponse>("/scan/hawb/inbound", payload);
  }
}


